import React from 'react';

const HEADER_VARIANTS = {
  primary:
    'border-b border-gray-100 bg-gradient-to-r from-primary-50/90 via-white to-white',
  slate: 'border-b border-gray-100 bg-gradient-to-r from-slate-50 to-white',
  emerald:
    'border-b border-gray-100 bg-gradient-to-r from-emerald-50/80 via-white to-white',
  amber: 'border-b border-gray-100 bg-gradient-to-r from-amber-50/80 via-white to-white',
  violet:
    'border-b border-gray-100 bg-gradient-to-r from-violet-50/70 via-white to-white',
};

const ICON_VARIANTS = {
  primary: 'bg-primary-100 text-primary-800 ring-1 ring-primary-200/50',
  slate: 'bg-slate-100 text-slate-800 ring-1 ring-slate-200/80',
  emerald: 'bg-emerald-100 text-emerald-900 ring-1 ring-emerald-200/60',
  amber: 'bg-amber-100 text-amber-900 ring-1 ring-amber-200/60',
  violet: 'bg-violet-100 text-violet-900 ring-1 ring-violet-200/60',
};

/**
 * Bloco de formulário no padrão da Licença assistida por IA: cartão, cabeçalho com ícone e faixa suave.
 */
const FormSection = ({
  id,
  title,
  description,
  icon: Icon,
  variant = 'primary',
  children,
  className = '',
  bodyClassName = 'p-5 sm:p-6',
  noIcon = false,
}) => {
  const head = HEADER_VARIANTS[variant] || HEADER_VARIANTS.primary;
  const iconBox = ICON_VARIANTS[variant] || ICON_VARIANTS.primary;

  return (
    <section
      className={`overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm ${className}`}
      aria-labelledby={id}
    >
      <div className={`flex flex-col gap-1 px-5 py-4 sm:flex-row sm:items-center sm:gap-4 ${head}`}>
        {!noIcon && Icon && (
          <div
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${iconBox}`}
          >
            <Icon className="h-5 w-5" aria-hidden />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h2 id={id} className="text-base font-semibold tracking-tight text-gray-900">
            {title}
          </h2>
          {description ? (
            <p className="mt-0.5 text-xs text-gray-500">{description}</p>
          ) : null}
        </div>
      </div>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
};

export default FormSection;
